import { useCallback, useState } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import LoadingSpinner from 'components/Common/Loading/LoadingSpinner'

const AnimationWrapper = styled.div`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: ${rem(40)};
  height: ${rem(40)};

  @media (prefers-reduced-motion: reduce) {
    display: none;
  }

  > * {
    grid-area: 1 / 1;
  }
`

const AnimationImage = styled(Image)`
  [dir="rtl"] & {
    scale: -1 1;
    transform-box: fill-box;
    transform-origin: center;
  }
`

interface Props {
  imageId: string
}

function ChatLoadingAnimation({ imageId }: Props) {
  const [loadedImageId, setLoadedImageId] = useState<string>()
  const handleLoad = useCallback(() => setLoadedImageId(imageId), [imageId])

  return (
    <AnimationWrapper aria-hidden>
      <AnimationImage id={imageId} width={40} height={40} alt="" format="gif" onLoad={handleLoad} />
      {loadedImageId !== imageId && <LoadingSpinner />}
    </AnimationWrapper>
  )
}

export default ChatLoadingAnimation
